import type { ThemeColors } from '../../../../tokens/colors/types';
import { border } from './border';
import { divider } from './divider';
import { blue, green, neutral, orange, pale, purple, red } from './palette';
import { deals, retail } from './product';
import { critical, info, positive, shout, warning } from './semantic';
import { typography } from './typography';

const primary = {
  '10': '#FFF7F2',
  '20': '#FFF0E6',
  '30': '#FF944D',
  '50': '#DE5900',
  '70': '#6A3A1B',
  '80': '#863702',
  '90': '#3B1800',
};

const secondary = {
  '20': '#FFFAE5',
  '30': '#FFEDA3',
  '50': '#FDE74C',
  '70': '#DBAF00',
  '90': '#8F7200',
};

const baseColors: ThemeColors = {
  blue,
  green,
  red,
  orange,
  primary,
  secondary,
  purple,
  neutral,
  pale,
  info,
  warning,
  critical,
  positive,
  deals,
  retail,
  shout,
  border,
  divider,
  typography,
};

export default baseColors;
